import { useRouter } from 'next/router';
import Footer from '@buddieshr/components/footer';
import Header from '@buddieshr/components/header';
import MetaHeader from '@buddieshr/components/metaHeader';
import { FooterCTA } from '@buddieshr/components/landing/sections';
import { BestSlackAppsArticle } from '@buddieshr/components/bestSlackApps/sections';

export default function BestSlackApps({ refSource }) {
  const router = useRouter();
  return (
    <>
      <MetaHeader
        title={'Best Slack Apps for Engagement & Productivity | BuddiesHR'}
        description={
          'Best Slack apps for team communication, project updates, and engagement. Get the integrations that reduce context switching and make work more efficient.'
        }
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/best-slack-apps`}
        pageSlug="best-slack-apps"
        locale={router.locale}
      />
      <Header />
      <main className="bh">
        <BestSlackAppsArticle />
        <FooterCTA />
      </main>
      <Footer refSource={refSource} />
    </>
  );
}
